module.exports = __webpack_public_path__ + "static/04_ashley_mulroney-7f3951d63fc3be02597bbb833d5d858d.jpg";